module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "Regular Review",
      "width": "750"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    staticClass: "evaluate"
  }, [_c('h3', [_vm._v("Part one： Classroom status(minimum 2 stars, maximum 5 stars)  :")]), _vm._v(" "), _c('Form', {
    ref: "formData",
    staticClass: "feedback form regluarForm",
    attrs: {
      "label-position": "top"
    },
    model: {
      value: (_vm.formData),
      callback: function($$v) {
        _vm.formData = $$v
      },
      expression: "formData"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Student's attention to the class："
    }
  }, [_c('el-rate', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.formData.rate1),
      callback: function($$v) {
        _vm.$set(_vm.formData, "rate1", $$v)
      },
      expression: "formData.rate1"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Class participation："
    }
  }, [_c('el-rate', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.formData.rate2),
      callback: function($$v) {
        _vm.$set(_vm.formData, "rate2", $$v)
      },
      expression: "formData.rate2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Classroom environment："
    }
  }, [_c('el-rate', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.formData.rate3),
      callback: function($$v) {
        _vm.$set(_vm.formData, "rate3", $$v)
      },
      expression: "formData.rate3"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Internet connection："
    }
  }, [_c('el-rate', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.formData.rate4),
      callback: function($$v) {
        _vm.$set(_vm.formData, "rate4", $$v)
      },
      expression: "formData.rate4"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "evaluate"
  }, [_c('h3', [_vm._v("Part two: Class performance   :")]), _vm._v(" "), _c('el-alert', {
    attrs: {
      "closable": false,
      "title": "I'm very happy to see you today. You have made wonderful progress participating the class activities and  I look forward to seeing you in the next class.",
      "type": "info",
      "description": "There are some difficult parts in today's lesson, so please review and practice the following areas after class."
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "square"
  }, [_vm._v("\n        1.Pronunciation of the words: \n        "), _c('el-row', [_c('div', {
    staticClass: "myList"
  }, [_c('el-col', {
    attrs: {
      "offset": 1
    }
  }, _vm._l((_vm.formData.word1), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.remark),
        expression: "item.remark"
      }],
      staticClass: "msg",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.remark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "remark", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-remove-outline",
      staticStyle: {
        "font-size": "20px",
        "margin-top": "10px",
        "cursor": "pointer",
        "color": "#FF463B"
      },
      on: {
        "click": function($event) {
          return _vm.deleteItem(_vm.formData.word1, index, 3)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-circle-plus-outline",
      staticStyle: {
        "font-size": "20px",
        "margin-top": "10px",
        "cursor": "pointer",
        "color": "#0ABB08"
      },
      on: {
        "click": function($event) {
          return _vm.addItem(_vm.formData.word1)
        }
      }
    })])
  }), 0)], 1)])], 1), _vm._v(" "), _c('p', {
    staticClass: "square"
  }, [_vm._v("\n        2.Usage of the words: \n        "), _c('el-row', [_c('div', {
    staticClass: "myList"
  }, [_c('el-col', {
    attrs: {
      "offset": 1
    }
  }, _vm._l((_vm.formData.word2), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.remark),
        expression: "item.remark"
      }],
      staticClass: "msg",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.remark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "remark", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-remove-outline",
      staticStyle: {
        "font-size": "20px",
        "margin-top": "10px",
        "cursor": "pointer",
        "color": "#FF463B"
      },
      on: {
        "click": function($event) {
          return _vm.deleteItem(_vm.formData.word2, index, 3)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-circle-plus-outline",
      staticStyle: {
        "font-size": "20px",
        "margin-top": "10px",
        "cursor": "pointer",
        "color": "#0ABB08"
      },
      on: {
        "click": function($event) {
          return _vm.addItem(_vm.formData.word2)
        }
      }
    })])
  }), 0)], 1)])], 1), _vm._v(" "), _c('p', {
    staticClass: "square"
  }, [_vm._v("\n        3.Difficult sentences: \n        "), _c('el-row', [_c('div', {
    staticClass: "myList"
  }, [_c('el-col', {
    attrs: {
      "offset": 1
    }
  }, _vm._l((_vm.formData.word3), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.remark),
        expression: "item.remark"
      }],
      staticClass: "msg",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.remark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "remark", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-remove-outline",
      staticStyle: {
        "font-size": "20px",
        "margin-top": "10px",
        "cursor": "pointer",
        "color": "#FF463B"
      },
      on: {
        "click": function($event) {
          return _vm.deleteItem(_vm.formData.word3, index, 1)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-circle-plus-outline",
      staticStyle: {
        "font-size": "20px",
        "margin-top": "10px",
        "cursor": "pointer",
        "color": "#0ABB08"
      },
      on: {
        "click": function($event) {
          return _vm.addItem(_vm.formData.word3)
        }
      }
    })])
  }), 0)], 1)])], 1), _vm._v(" "), _c('p', {
    staticClass: "square"
  }, [_vm._v("\n        4.Others(grammar, writing etc): \n        "), _c('el-row', [_c('div', {
    staticClass: "myList"
  }, [_c('el-col', {
    attrs: {
      "offset": 1
    }
  }, _vm._l((_vm.formData.word4), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.remark),
        expression: "item.remark"
      }],
      staticClass: "msg",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.remark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "remark", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-remove-outline",
      staticStyle: {
        "font-size": "20px",
        "margin-top": "10px",
        "cursor": "pointer",
        "color": "#FF463B"
      },
      on: {
        "click": function($event) {
          return _vm.deleteItem(_vm.formData.word4, index, 1)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-circle-plus-outline",
      staticStyle: {
        "font-size": "20px",
        "margin-top": "10px",
        "cursor": "pointer",
        "color": "#0ABB08"
      },
      on: {
        "click": function($event) {
          return _vm.addItem(_vm.formData.word4)
        }
      }
    })])
  }), 0)], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "evaluate"
  }, [_c('h3', [_vm._v("Other feedback（optional）:")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("\n        1. A message to the parent\n      ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Enter something..."
    },
    model: {
      value: (_vm.formData.parent),
      callback: function($$v) {
        _vm.$set(_vm.formData, "parent", $$v)
      },
      expression: "formData.parent"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("\n        2. Homework\n      ")]), _vm._v(" "), _c('MultiUpload', {
    staticClass: "title",
    attrs: {
      "num": 1,
      "defaultFileList": _vm.formData.fileList
    },
    on: {
      "on-file-change": _vm.changeFile
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("\n        3.Student needs to adjust the material level\n      ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Enter something..."
    },
    model: {
      value: (_vm.formData.levelMsg),
      callback: function($$v) {
        _vm.$set(_vm.formData, "levelMsg", $$v)
      },
      expression: "formData.levelMsg"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (!_vm.readonly) ? _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Submit")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6445f384","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/StudentWriteReviewRegularModal.vue
// module id = 1858
// module chunks = 8